/** The `code` of a coach_api error envelope, or null when the body is not one. */
export async function exportErrorCode(response: Response): Promise<string | null> {
    try {
        const body = (await response.clone().json()) as { code?: unknown };
        return typeof body.code === "string" ? body.code : null;
    } catch {
        return null;
    }
}

export const TOO_FEW_PARTICIPANTS_CODE = "too_few_participants_to_export";
export const CAMPAIGN_NOT_CLOSED_CODE = "campaign_not_closed";
/** Mirrors `MIN_EXPORT_PARTICIPANTS` in coach_core; only used to word the message. */
export const MIN_EXPORT_PARTICIPANTS = 3;
/** Mirrors `MIN_INDIVIDUAL_REPORT_PARTICIPANTS` in coach_core: the pooled individual 360 report and its CSV need this many people. */
export const MIN_INDIVIDUAL_REPORT_PARTICIPANTS = 5;
